import { useContext } from "react";
import classNames from "classnames";
import { FloatingButton } from "@livingmap/hippo";

import { MapContext } from "../../../../Map";
import { PinyinCandidate } from "../../../../../../services/pinyinService";

import styles from "./PinyinSuggestions.module.scss";

interface Props {
  candidates: PinyinCandidate[];
  onCandidateSelect: (candidate: PinyinCandidate) => void;
  dataQA?: string;
}

const PinyinSuggestions: React.FC<Props> = ({
  candidates,
  onCandidateSelect,
  dataQA = "pinyin-suggestions",
}) => {
  const { controlTheme } = useContext(MapContext);

  return (
    <div
      data-qa={dataQA}
      className={classNames(styles.container, styles[controlTheme])}
      style={{ visibility: candidates.length === 0 ? "hidden" : "visible" }}
    >
      {/* Show suggestion pills */}
      <div className={styles.row}>
        {candidates.map((candidate, index) => (
          <FloatingButton
            key={`${candidate.text}-${index}`}
            dataQA={`suggestion-${index}`}
            // eslint-disable-next-line react/style-prop-object
            style="filled"
            type="primary-inverse"
            text={candidate.text}
            onClick={() => onCandidateSelect(candidate)}
            size="regular"
            className={styles.pill}
          />
        ))}
      </div>
    </div>
  );
};

export default PinyinSuggestions;
